import { render, staticRenderFns } from "./receivable.vue?vue&type=template&id=ba13a198&scoped=true&"
import script from "./receivable.vue?vue&type=script&lang=js&"
export * from "./receivable.vue?vue&type=script&lang=js&"
import style0 from "./receivable.vue?vue&type=style&index=0&id=ba13a198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba13a198",
  null
  
)

export default component.exports